module.exports = __webpack_public_path__ + "static/media/sow-section-3-student.cf6f37b4.svg";